import { LessonDefinition } from "../../types";

const lesson: LessonDefinition = {
  id: "export-and-discovery",
  courseId: "investigations",
  order: 10,
  title: "Export and discovery",
  subtitle: "Summary, lead sheet, package",
  summary:
    "The header Export menu produces three deliverables: a clean summary, a lead sheet, and the complete discovery ZIP with every transcript, log, and dismissed lead.",
  learn: [
    "Export the Brief as a summary PDF or Word document",
    "Produce the lead sheet",
    "Build the discovery package and know what is in it",
  ],
  minutes: 3,
  releasedAt: "2026-08-24T00:00:00.000Z",
  gate: "investigations",
  body: [
    {
      type: "steps",
      items: [
        "Click **Export** in the investigation header.",
        "Choose Investigation summary for the current Brief as a deliverable (no revision notes), as PDF or Word.",
        "Choose Lead sheet for every lead with status, severity, quote, and source.",
        "Choose Timeline for the chronology with the same filters as the tab.",
        "Choose Discovery package for the ZIP.",
      ],
    },
    { type: "heading", text: "What the discovery package contains" },
    {
      type: "bullets",
      items: [
        "Summary and lead sheet, each as PDF and Word.",
        "A transcript text file per call, and your chat logs.",
        "leads.csv, files.csv, and audit-log.csv.",
        "raw-data.json: the full AI record, including dismissed leads, every brief version, and chat history.",
      ],
    },
    {
      type: "callout",
      tone: "warning",
      title: "The package is not curated",
      text: "It is built for disclosure, so dismissed leads, hidden timeline items, and your chat questions are all included on purpose. If you want a curated deliverable, send the summary export instead.",
    },
    {
      type: "paragraph",
      text: "Every file deletion, privilege mark, and export is logged in the audit trail that ships in the package.",
    },
    {
      type: "paragraph",
      text: "To turn the investigation into a narrative instead, read Draft a report.",
    },
  ],
  related: ["draft-a-report-from-an-investigation", "read-the-brief", "work-the-leads-queue"],
};

export default lesson;
